var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', [
        _c('div', {
            staticClass: "bottom-tips"
        }, [
            _vm._v(" Para la protección de datos, consulte la "),
            _c('a', {
                attrs: {
                    "href": "javascript:;"
                },
                on: {
                    "click": function($event) {
                        $event.stopPropagation();
                        return _setup.onOpenAgreement('privacy');
                    }
                }
            }, [
                _c('span', [
                    _vm._v("AVISO DE PRIVACIDAD")
                ])
            ]),
            _vm._v(" y "),
            _c('a', {
                attrs: {
                    "href": "javascript:;"
                },
                on: {
                    "click": function($event) {
                        $event.stopPropagation();
                        return _setup.onOpenAgreement('data');
                    }
                }
            }, [
                _c('span', [
                    _vm._v("DECLARACIÓN DE DIVULGACIÓN DESTACADA")
                ])
            ]),
            _vm._v(" . ")
        ]),
        _c(_setup.RegisterPrivacyPopup, {
            attrs: {
                "type": _setup.agreementType
            },
            model: {
                value: _setup.visibleMap.agreement,
                callback: function callback($$v) {
                    _vm.$set(_setup.visibleMap, "agreement", $$v);
                },
                expression: "visibleMap.agreement"
            }
        })
    ], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
